import { ShippingLineInterface } from '../interfaces/api';

export class ShippingLine implements ShippingLineInterface {

    abbr: string;

    address1: string;

    address2: string;

    address3: string;

    city: string;

    country: string;

    email: string;

    fax: string;

    id: number;

    logo_url: string;

    name: string;

    postcode: string;

    telephone: string;

    get logo(): string {
        return this.logo_url;
    }


    static createFromObject(object: any): ShippingLine {
        let shippingLine: ShippingLine = new ShippingLine();
        if (object.abbr !== undefined)
            shippingLine.abbr = object.abbr;
        if (object.address1 !== undefined)
            shippingLine.address1 = object.address1;
        if (object.address2 !== undefined)
            shippingLine.address2 = object.address2;
        if (object.address3 !== undefined)
            shippingLine.address3 = object.address3;
        if (object.city !== undefined)
            shippingLine.city = object.city;
        if (object.country !== undefined)
            shippingLine.country = object.country;
        if (object.email !== undefined)
            shippingLine.email = object.email;
        if (object.fax !== undefined)
            shippingLine.fax = object.fax;
        if (object.id !== undefined)
            shippingLine.id = object.id;
        if (object.logo_url !== undefined)
            shippingLine.logo_url = object.logo_url;
        if (object.name !== undefined)
            shippingLine.name = object.name;
        if (object.postcode !== undefined)
            shippingLine.postcode = object.postcode;
        if (object.telephone !== undefined)
            shippingLine.telephone = object.telephone;
        return shippingLine;
    }

    static createFromObjects(objects: any[]): ShippingLine[] {
        let shippingLines: ShippingLine[] = [];
        for (let object of objects) {
            shippingLines.push(ShippingLine.createFromObject(object));
        }
        return shippingLines;
    }
}



// WEBPACK FOOTER //
// ./src/entities/shipping-line.ts